import { useEffect } from "react";
import { Loader } from "components/UI/atoms";
import { useBrandAlertContext } from "context/brand-alert-context";
import { MODAL_TITLES } from "./utils/constants";
import { POSSIBLE_MODAL_ALERT_CONTENTS } from "constants/brands";
import {
  BrandAlertCancelConfirm,
  BrandAlertCanceled,
  BrandAlertModalForm,
  BrandAlertSuccessFeedback,
  Modal
} from "..";
import "./index.scss";

const {
  FORM_ALERT,
  SUCCESS_FEEDBACK,
  CANCEL_CONFIRMATION,
  CANCEL_ALERT_FEEDBACK
} = POSSIBLE_MODAL_ALERT_CONTENTS;

export const BrandAlertModal = ({
  isOpen,
  handleClose,
  productSourceId,
  name
}) => {
  const {
    isInitialLoading,
    saveBrandAlert,
    setCurrentContent,
    cancelAlert,
    resetAlert,
    currentContent,
    getCurrentBrandAlert,
    setProductSourceId
  } = useBrandAlertContext();

  const handleCloseModal = () => {
    setCurrentContent(POSSIBLE_MODAL_ALERT_CONTENTS.FORM_ALERT);
    handleClose();
  };

  const getCurrentComponent = () => {
    switch (currentContent) {
      case FORM_ALERT:
        return (
          <BrandAlertModalForm
            initialValues={getCurrentBrandAlert({ productSourceId })}
            onSaveBrandAlert={saveBrandAlert}
            handleCancelAlert={() =>
              setCurrentContent(
                POSSIBLE_MODAL_ALERT_CONTENTS.CANCEL_CONFIRMATION
              )
            }
            brandName={name}
          />
        );
      case SUCCESS_FEEDBACK:
        return (
          <BrandAlertSuccessFeedback
            name={name}
            handleClose={handleCloseModal}
          />
        );
      case CANCEL_CONFIRMATION:
        return (
          <BrandAlertCancelConfirm
            handleCancelAlert={() => cancelAlert({ productSourceId })}
            handleKeepAlert={() =>
              setCurrentContent(POSSIBLE_MODAL_ALERT_CONTENTS.FORM_ALERT)
            }
          />
        );
      case CANCEL_ALERT_FEEDBACK:
        return (
          <BrandAlertCanceled
            handleAddBrandAlert={() =>
              setCurrentContent(POSSIBLE_MODAL_ALERT_CONTENTS.FORM_ALERT)
            }
            handleResetAlert={() => void resetAlert()}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    setProductSourceId(productSourceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSourceId]);

  return (
    <Modal
      isOpen={isOpen}
      onBackdropClick={handleCloseModal}
      header={<h3>{MODAL_TITLES[currentContent] || ""}</h3>}
      customClassName="brand-alert-modal"
      data-testid="brand-alert-modal"
    >
      {isInitialLoading ? (
        <Loader id="modal-loader" variant="secondary" />
      ) : (
        getCurrentComponent()
      )}
    </Modal>
  );
};
